export default {"src":"/_next/static/media/trash.de988225.svg","height":29,"width":25};